import { defineStore } from "pinia";

import {getMyDashboards,fetchDashboardTaskDetails,} from "@/api/campaignApi";
import { DashboardTypes } from "@/domain/dashboardDomain";
import { toast } from "vue3-toastify";

import { createPinia } from "pinia";
import { useMessagingStore } from "@/stores/messagingStore";

import msalApi from "../config/setupMSALAxios"; // your configured Axios instance

export interface DashboardValue {
  containerId: string;
  name: string;
  primaryLabel: string;
  primaryValue: number;
  secondaryLabel: string;
  secondaryValue: number;
}
export interface IPriorityItem {
  category: string;
  dashboardValues: DashboardValue[];
}

export interface ICodingProblem {
  containerId: number;
  name: string;
  primaryLabel: string;
  primaryValue: number;
  secondaryLabel: string;
  secondaryValue: number;
}

export interface ICodingProblems {
  name: string;
  items: ICodingProblem[];
}

export const useDashboardsStore = defineStore("dashboardsStore", {
  state: () => ({
    dashboards: [],
    userSelectedDate: Date,
    showHomePage: true,
    codingIssues: {
      codingIssueCategories: [] as ICodingProblem[],
      priorityItems: [] as IPriorityItem[],
    },
    diseaseManagement: {},
  }),
  actions: {
    resetState() {
      this.dashboards = [];
      this.codingIssues.codingIssueCategories = [];
      this.codingIssues.priorityItems = [];
    },
    async fetchDashboards() {
      const result = await getMyDashboards();
      if (!result.ok) {
        toast.error(`Couldn't retrieve dashboards. Please contact technical support with ${result.errorId}`);
        return this.showHomePage;
      }

      this.resetState();

      const dashboards = result.payload.dashboards;
      if (dashboards) {
        // commit("setDashboards", dashboards);
        this.setDashboards(dashboards)
        dashboards.forEach((dashboard) => {
          switch (dashboard.id) {
            case DashboardTypes.CodingIssues:
              const { campaignItems, priorityItems } = dashboard.items;
              if (campaignItems.length !== 0) this.setCodingProblems(campaignItems);
              if (priorityItems.length !== 0) this.setPriorityItems(priorityItems);
              if (campaignItems.length !== 0 || priorityItems.length !== 0) this.setShowHomePage(false);
              break;
            case DashboardTypes.Tasks:
              if (dashboard.items.length !== 0) {
                // commit("setMessagesStore", dashboard.items, { root: true });

// console.log(' HOOK  to messagingStore ')
                const messagingStore = useMessagingStore();
                messagingStore.setMessagesStore(dashboard.items)

                // commit("setShowHomePage", false);
                this.setShowHomePage(false)
              }
              break;
            case DashboardTypes.DelegatedWork:
              if (dashboard.items.length !== 0) {
// console.log(`got some delegated work: ${dashboard.items}`);
              }
              break;
          }
        });
      }
      return this.showHomePage;
    },
    async fetchCodingIssuesDetails({ commit, state }: any, containerId: number) {
      const result =  fetchDashboardTaskDetails(containerId);
      return result;
    },
    setDashboards(dashboards) {
      this.dashboards = dashboards.map((db) => ({
        name: db.name,
        id: db.id,
      }));
    },
    setCodingProblems(codingProblems) {
      const mapped = codingProblems.map((campaignItem) => {
        const name = campaignItem.category as string;
        const items = campaignItem.dashboardValues as ICodingProblem[];
        const campaign: ICodingProblems = {
          name,
          items: items,
        };
        return campaign;
      });
      this.codingIssues.codingIssueCategories = mapped;
    },

    setPriorityItems(priorityItems) {
      this.codingIssues.priorityItems = priorityItems;
    },
    setShowHomePage(show) {
      this.showHomePage = show;
    },
  },
  getters: {
    // codingIssues: (state) => state.codingIssues.codingIssueCategories,
    // priorityItems: (state) => state.codingIssues.priorityItems,
    // showHomePage: (state) => state.showHomePage,
    // showCodingIssuesDashboard: (state) => state.codingIssues.codingIssueCategories.length || state.codingIssues.priorityItems.length,
    // getDashboards: (state) => state.dashboards,
  },

});
